import Link from "next/link";

// link: { internal: boolean, href: string, as: string }
const DynamicNextLink = ({ className, link, children }) => {
  let html;
  if (link) {
    const { internal, href, as } = link;
    if (internal) {
      html = (
        <Link as={as} href={href} prefetch>
          <a>{children}</a>
        </Link>
      );
    } else {
      html = (
        <a
          href={href}
          target="_blank"
          rel={href.indexOf("mailto:") > -1 ? "" : "noopener"}
        >
          {children}
        </a>
      );
    }
  } else {
    html = <div>{children}</div>;
  }
  return <div className={className}>{html}</div>;
};

export { DynamicNextLink };
